enum Tab {
  Home = 0,
}
enum MediaType {
  Video = 0,
  Image = 1,
}
export { Tab, MediaType };
